import React from 'react'
import Modal from '@mui/material/Modal';
import { useState } from 'react';
import { Button, Grid, Paper, TextField, Alert, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';
import { api_url } from '../config';
import styles from './table.module.css';
import color from 'color'
import moment from 'moment';


const ViewModal = ({ tree_id, token }) => {

    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [res, setRes] = useState([]);
    const [loader, setLoader] = useState(false);
    const closeHandler = () => {
        setVisible(false);
        console.log("closed");
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        bradius: '5px',
        boxShadow: 24,
        p: 4,
    };

    const handler = async () => {
        try {
            setLoading(true);
            // console.log(1)
            const { data: obj } = await axios({
                url: api_url + '/mission-vriksh-get-history',
                method: 'post',
                responseType: 'json',
                data: {
                    tree_id: tree_id,
                    token: token,
                }
            })
            if (obj.success === 'ok') {
                setRes(obj.array);
                setVisible(true);
            }
        }
        catch (e) {
            alert(e.message);
        }
        finally {
            setLoading(false);
        }
    }



    return (

        <div>

            <Button style={{ color: '#b11116' }} fullWidth onClick={handler}><b>View</b></Button>

            {visible && <Modal
                open={visible}
                onClose={closeHandler}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Paper sx={style} style={{ padding: '27px', backgroundColor: 'seashell', borderRadius: '10px' }}>

                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th colSpan={7} style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Plantation History</th>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Tree Id</th>
                                <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Month</th>
                                <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Front Image</th>
                                <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Left Image</th>
                                <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Right Image</th>
                                <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Top Image</th>
                                <th style={{ backgroundColor: color('#7E9B24').lighten(0.2) }}>Clicked At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {res.map((ele, i) => (
                                <tr>
                                    <td>{ele.tree_data_id}</td>
                                    <td>{ele.month}</td>
                                    <td><a href={ele.front_image} target="_blank">click</a></td>
                                    <td><a href={ele.left_image} target="_blank">click</a></td>
                                    <td><a href={ele.right_image} target="_blank">click</a></td>
                                    <td><a href={ele.top_image} target="_blank">click</a></td>
                                    <td>{moment(ele.created_at).format('Do MMMM YYYY')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Paper>
            </Modal>}

        </div>
    )
}

export default ViewModal;
